// src/components/Header.js

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // A tag <Link> já está aqui
import { db, auth } from '../firebase';
import { collection, getDocs } from "firebase/firestore";
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth"; // Importa as funções de login do Google
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';
import '../App.css';

const Header = () => {
  const [categories, setCategories] = useState([]);
  const { currentUser, userRole } = useAuth();// Pega o usuário logado do nosso contexto
  const navigate = useNavigate(); // Hook para redirecionar o usuário após ações
  // Função que abre o Popup de Login do Google
  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      // Após o login, podemos redirecionar para uma página de dashboard
      navigate('/admin/dashboard'); 
    } catch (error) {
      // Exibe o erro exato do Firebase em um alerta para depuração
      alert(`Erro ao fazer login: ${error.code}\n\nMensagem: ${error.message}`);
      console.error("Erro ao fazer login com Google:", error);
    }
  };

  // Função para fazer o logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      // Após o logout, redireciona para a página inicial
      navigate('/');
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      const categoriesRef = collection(db, "blog_categorias");
      const categorySnapshot = await getDocs(categoriesRef);
      const categoriesData = categorySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCategories(categoriesData);
    };

    fetchCategories();
  }, []);

  return (
    <header className="main-header">
      <div className="container">
        <Link to="/"><img src={logo} alt="Logo da Primo Trade Solutions - Desenvolvimento de Apps" className="logo-image" /></Link>
        <nav>
          <div className="nav-dropdown">
            <Link to="/" className="nav-link">Página Inicial</Link>
            <div className="dropdown-content">
              <a href="/#about" className="nav-link">Sobre Nós</a>
              <Link to="/termos-e-condicoes">Termos e Condições</Link>
              <Link to="/politica-de-privacidade">Política de Privacidade</Link>
              
            </div>
          </div>

          

          {/* O NOVO HUB DE PRODUTOS */}
          <div className="nav-dropdown">
            <span className="nav-link" style={{cursor: 'pointer'}}>Produtos</span>
            <div className="dropdown-content">
              <Link to="/IAdoAsfalto">🧪 IA do Asfalto (SaaS)</Link>
              <Link to="/rpa-e-automacao">🤖 RPA e Automação de Software</Link>
              <Link to="/certificado-digital">🪪 Certificado Digital</Link>
            </div>
          </div>

          <div className="nav-dropdown">
            <Link to="/blog" className="nav-link">Blog</Link>
            <div className="dropdown-content">
              <Link to="/blog">Todas as categorias</Link>
              {/* ↓↓↓ ALTERAÇÃO AQUI ↓↓↓ */}
              {categories.map(category => (
                // Trocamos <a> por <Link> e ajustamos o 'to'
                <Link to={`/blog/categoria/${category.slug}`} key={category.id}>
                  {category.label}
                </Link>
              ))}
            </div>
          </div>

          { currentUser ? (
            <div className="nav-dropdown">
              <span className="nav-link" style={{cursor: 'pointer'}}>{currentUser.displayName}</span>
              <div className="dropdown-content">
                {/* Lógica condicional para o link do painel */}
                {userRole === 'admin' ? (
                  <Link to="/admin">Painel Admin</Link>
                ) : (
                  <Link to="/dashboard">Meu Painel</Link>
                )}
                {/* AQUI A CORREÇÃO: trocamos <a> por <button> */}
                <button 
                  onClick={handleLogout} 
                  style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    padding: '12px 16px', width: '100%', textAlign: 'left',
                    color: 'black', fontFamily: 'inherit', fontSize: '0.9rem'
                  }}
                >
                  Sair
                </button>
              </div>
            </div>
            ) : (
            // AQUI A CORREÇÃO: trocamos <a> por <button>
            <button onClick={handleGoogleLogin} className="nav-link" style={{background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit'}}>
                Entrar
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;